import React from "react";
import { Eight  } from "./Chart.config";
import ShreeDayTable from "./ShreeDayTable";

const ShreeDay = ({ chartData }) => {
    return <ShreeDayTable staticData={Eight} chartData={chartData} />;
};

export default ShreeDay;
